import {prop} from 'ramda';

import {DASHBOARD_TILE_SIZES} from '../consts/dashboardTileSizes';
import {DashboardTileSize} from '../types/DashboardTileSize';
import {DASHBOARD_GRID_COLUMNS} from './allocateDashboardGrid';

export const isDashboardTileFullWidth = (size: DashboardTileSize) =>
  prop(size, DASHBOARD_TILE_SIZES).columns === DASHBOARD_GRID_COLUMNS;
